<template>
    <b-form-row>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="this.id" :title="title">
            <BancoList :prefix="updatedPrefix" @onDblClickBanco="bancoSelect" />
        </b-modal>

        <lg-form-input-finder :disabled="disabled" :value="computedValue" @input="updateValue" fieldDescription="nome" :label="label"
            invalidFeedback="Banco deve ser informado!" description="" @handleClean="handleClean">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import BancoList from "@/modules/cadastros/banco/BancoList.vue"

export default {
    components: { LgFormInputFinder, BancoList },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        id: String,
        prefix: Array,
        value: Object,
        label: {
            type: String,
            default: ''
        }
    },
    data() {

        return {
            internalValue: this.value || {},
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue
            },
            set(newValue) {
                this.internalValue = newValue
            },
        },
        updatedPrefix() {
            return [...this.prefix, "Banco"]
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id)
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit('input', newValue)
        },
        handleClean() {
            this.computedValue = {}
            this.$emit('input', {})
        },
        bancoSelect(item) {
            this.computedValue = item
            this.$emit('input', item)
            this.$bvModal.hide(this.id)
        },
    },
}
</script>
